






























































import Vue, { PropType } from 'vue';
import { User } from '@/types';

type Data = {
  user: User | null;
  dialog: boolean;
};

export default Vue.extend({
  props: {
    user_id: {
      type: Number as PropType<number>,
      required: true
    }
  },
  data(): Data {
    return {
      user: null,
      dialog: false
    };
  },
  watch: {
    dialog(v) {
      if (v) {
        this.load();
      }
    }
  },
  methods: {
    close() {
      this.dialog = false;
      this.cleanError();
    },
    load() {
      this.$store.api.user(this.user_id).then(user => {
        this.user = user;
      }).catch(this.setError);
    },
    save() {
      const { user } = this;
      if (!user) {
        return;
      }
      this.startSaving();
      this.$store.api.editUser({
        user_id: user.id,
        name: user.name,
        roles: user.roles
      }).then(() => {
        this.$store.change();
        this.close();
      }).catch(this.setError).then(this.stopSaving);
    }
  }
});
